import { Helmet } from "react-helmet-async";

const SITE_NAME = "Freitag-Gruppe";
const BASE_URL = "https://www.freitag-bs.de";

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Freitag-Gruppe",
  "url": BASE_URL,
  "logo": `${BASE_URL}/images/bau-hero.jpg`,
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+49-531-874610",
    "contactType": "customer service",
    "availableLanguage": "German",
    "hoursAvailable": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
      "opens": "10:00",
      "closes": "14:00"
    }
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Hinter dem Turme 29",
    "addressLocality": "Braunschweig",
    "postalCode": "38114",
    "addressCountry": "DE"
  },
  "sameAs": []
};

const LOCAL_BUSINESS_BASE = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Bauunternehmung Freitag GmbH",
  "image": `${BASE_URL}/images/bau-hero.jpg`,
  "url": BASE_URL,
  "telephone": "+49-531-874610",
  "email": "info@freitag-bs.de",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Hinter dem Turme 29",
    "addressLocality": "Braunschweig",
    "postalCode": "38114",
    "addressRegion": "Niedersachsen",
    "addressCountry": "DE"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 52.2689,
    "longitude": 10.5268
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
    "opens": "10:00",
    "closes": "14:00"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "6",
    "reviewCount": "6"
  },
  "areaServed": {
    "@type": "GeoCircle",
    "geoMidpoint": { "@type": "GeoCoordinates", "latitude": 52.2689, "longitude": 10.5268 },
    "geoRadius": "20000"
  }
};

const PAGE_SCHEMAS = {
  home: [
    ORGANIZATION_SCHEMA,
    {
      ...LOCAL_BUSINESS_BASE,
      "description": "Die Freitag-Gruppe aus Braunschweig vereint Bausanierung, Tiefbau, Garten- und Landschaftsbau sowie Sachverständigenbüro unter einem Dach.",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Leistungen der Freitag-Gruppe",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bausanierung" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Kellerabdichtungen" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Tiefbau" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Pflasterarbeiten" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Gartengestaltung" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Sachverständigenbüro" } }
        ]
      }
    }
  ],
  bauunternehmung: [{
    ...LOCAL_BUSINESS_BASE,
    "@type": "GeneralContractor",
    "name": "Freitag Bauunternehmung",
    "url": `${BASE_URL}/bauunternehmung`,
    "description": "Bauunternehmung Freitag GmbH in Braunschweig: Bausanierung, Kellerabdichtungen, Kellersanierungen, Tiefbau und Pflasterarbeiten.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Bauleistungen",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bausanierung", "description": "Fachgerechte Sanierung und Modernisierung bestehender Gebäude und Bauwerke." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Kellerabdichtungen", "description": "Professionelle Abdichtung von Kellern gegen Feuchtigkeit und drückendes Wasser." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Kellersanierungen", "description": "Umfassende Sanierung feuchter und beschädigter Kellerräume." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Tiefbau", "description": "Erd- und Kanalbauarbeiten sowie Infrastrukturprojekte." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Pflasterarbeiten", "description": "Fachgerechte Pflaster- und Wegearbeiten für Einfahrten, Terrassen und Gehwege." } }
      ]
    }
  }],
  galabau: [{
    ...LOCAL_BUSINESS_BASE,
    "@type": "LandscapingBusiness",
    "name": "Freitag Galabau",
    "url": `${BASE_URL}/galabau`,
    "image": `${BASE_URL}/images/galabau-hero.jpg`,
    "description": "Freitag Galabau in Braunschweig: Professionelle Gartengestaltung, Pflasterarbeiten, Bepflanzung und Grünflächenpflege.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Galabau-Leistungen",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Gartengestaltung", "description": "Individuelle Gartenplanung und -gestaltung." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Pflasterarbeiten", "description": "Professionelle Pflaster- und Wegearbeiten." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bepflanzung", "description": "Fachgerechte Bepflanzung mit standortgerechten Gehölzen und Stauden." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Rasen & Rollrasen", "description": "Rasenansäung, Rollrasenverlegung und Rasenpflege." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Grünpflege", "description": "Regelmäßige Pflege und Instandhaltung Ihrer Außenanlagen." } }
      ]
    }
  }],
  sachverstaendiger: [{
    ...LOCAL_BUSINESS_BASE,
    "@type": "ProfessionalService",
    "name": "Freitag Sachverständigenbüro",
    "url": `${BASE_URL}/sachverstaendiger`,
    "image": `${BASE_URL}/images/sv-hero.jpg`,
    "description": "Sachverständigenbüro Freitag in Braunschweig: Gutachten, Bauschadenbewertung, Wertermittlung, Dichtheitsprüfung, Generalinspektion Abscheider nach DIN EN 1610 und DIN 1986-30.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Sachverständigenleistungen",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Gutachten", "description": "Fundierte Gutachten für Immobilien und Bauprojekte." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bauschadenbewertung", "description": "Professionelle Identifikation und Bewertung von Bauschäden." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Wertermittlung", "description": "Marktgerechte Wertermittlung von Immobilien." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Generalinspektion Abscheider", "description": "Generalinspektion für Fettabscheider, Leichtflüssigkeitsabscheider und Benzinabscheider. Dichtigkeitsnachweise nach DIN EN 1610 und DIN 1986-30." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Beratung", "description": "Fachliche Beratung zu Immobilien, Baumängel und Werterhalt." } }
      ]
    }
  }]
};

export const SEOHead = ({ title, description, canonical, type = "website", noindex = false, schemaKey }) => {
  const fullTitle = title.includes("Freitag") ? title : `${title} | ${SITE_NAME}`;
  const fullUrl = `${BASE_URL}${canonical}`;
  const schemas = schemaKey ? PAGE_SCHEMAS[schemaKey] : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="de_DE" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {schemas && schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};
